import { gql } from '@apollo/client/core';
import CommentPreview from '@/apollo/fragments/Notification/NotificationCommentPreview.fragment';
import RatingPreview from '@/apollo/fragments/Notification/NotificationRatingPreview.fragment';
import PostPreview from '@/apollo/fragments/Notification/NotificationPostPreview.fragment';
import TestimonialPreview from '@/apollo/fragments/Notification/NotificationTestimonialPreview.fragment';
import JobsHiringPreview from '@/apollo/fragments/Notification/NotificationJobsHiringPreview.fragment';

const NotificationsQuery = gql`
  ${CommentPreview}
  ${RatingPreview}
  ${PostPreview}
  ${TestimonialPreview}
  ${JobsHiringPreview}

  query notifications($cursor: String, $platform: Platform) {
    notifications(after: $cursor, platform: $platform) {
      edges {
        node {
          id
          readAt
          createdAt
          type
          kind
          warRoomCommissionTransaction {
            id
            amount
          }
          referenceable {
            ... on Comment {
              ...CommentPreview
            }
            ... on Rating {
              ...RatingPreview
            }
            ... on Post {
              ...PostPreview
            }
            ... on Testimonial {
              ...TestimonialPreview
            }
            ... on JobsHiring {
              ...JobsHiringPreview
            }
            ... on User {
              slug
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export default NotificationsQuery;
